module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<input type="radio" name="'+
((__t=( radioName() ))==null?'':__t)+
'" data-input="'+
((__t=( radioName() ))==null?'':__t)+
'-radio" id="'+
((__t=( id ))==null?'':__t)+
'"> <label class="align-left" for="'+
((__t=( id ))==null?'':__t)+
'">'+
((__t=( name ))==null?'':__t)+
'</label>';
}
return __p;
};
